/* Input park: the cell editor converts with the Table round (component-map.md). */
import { Input } from '@chakra-ui/react';
import * as tp from '@main/shared/utils/timeperiod';

export type TimeBoundaryAbsoluteProps = {
  value: tp.TimeBoundaryAbsolute;
  onChange: (value: tp.TimeBoundaryAbsolute) => void;
  isDisabled?: boolean;
};

export const TimeBoundaryAbsolute = ({
  value,
  onChange,
  isDisabled,
}: TimeBoundaryAbsoluteProps) => {
  return (
    <Input
      type="date"
      value={value.timestamp.toISOString().split('T')[0]}
      onChange={(event) => {
        if (event.target.valueAsDate) {
          onChange({ ...value, timestamp: event.target.valueAsDate });
        }
      }}
      isDisabled={isDisabled}
    />
  );
};
